import { skipToken, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { createReportAdRequest, getReportAdStatusRequest } from "lib/api/reportAd";
import type { ReportAdInterface, ReportAdPayload, ReportAdStatusInterface } from "types/reportAd";

export const reportAdKeys = {
    all: ["reportAd"] as const,
    status: (adId: string | undefined) => [...reportAdKeys.all, "status", adId ?? "__missing__"] as const,
};

export const createReportAd = (adId: string, data: ReportAdPayload) =>
    parseResponse<ReportAdInterface>(createReportAdRequest(adId, data));

export const getReportAdStatus = (adId: string) =>
    parseResponse<ReportAdStatusInterface>(getReportAdStatusRequest(adId));

export const useReportAdStatus = (adId: string | undefined, enabled: boolean) =>
    useQuery({
        queryKey: reportAdKeys.status(adId),
        queryFn: adId && enabled ? () => getReportAdStatus(adId) : skipToken,
    });

export const useCreateReportAd = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ adId, data }: { adId: string; data: ReportAdPayload }) => createReportAd(adId, data),
        onSuccess: (_data, variables) => {
            void queryClient.invalidateQueries({ queryKey: reportAdKeys.status(variables.adId) });
        },
    });
};
